<script setup>
import { useRsvpStore } from '@/stores/rsvp/rsvp.store';

const rsvpStore = useRsvpStore();

const textFont =
  rsvpStore.clientData.common.textFont &&
  rsvpStore.clientData.common.textFont.trim() !== ''
    ? rsvpStore.clientData.common.textFont
    : 'Alegreya';
</script>

<template>
  <div class="wishes">
    <div class="images">
      <div
        v-for="(wish, i) in rsvpStore.getImages.rsvpWishes"
        :key="i"
        class="image"
      >
        <p
          v-if="
            rsvpStore.getWishes().lang[i].text &&
            rsvpStore.getWishes().lang[i].text !== ''
          "
          class="text"
        >
          {{ rsvpStore.getWishes().lang[i].text }}
        </p>
        <div class="img">
          <img :src="wish.url" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.image {
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  gap: 25px;
  justify-content: center;
  align-items: center;
  padding: 0 0 30px;
}

.img {
  margin: auto 10%;
}

.text {
  text-align: center;
  font-size: 1.7em;
  line-height: normal;
  font-family: v-bind(textFont), serif;

  @media screen and (max-width: $media-phone) {
    font-size: 1.4em;
  }
}

.title {
  font-size: 2em;
  text-align: center;

  @media screen and (max-width: $media-phone) {
    font-size: 1.65em;
  }
}
</style>
